import styles from "./SideBySide.module.css";
import BlokWrap from "@/components/bloks/BlokWrap";
import { SegmentControl } from "@/components/SegmentControl";
import type { BlokSideBySide } from "@/storyblok";
import {
	StoryblokComponent,
	StoryblokComponentList,
	type BlokProps,
} from "@frend-digital/storyblok";
import { clsx } from "@frend-digital/ui";

const MEDIA_COMPONENTS = ["fullWidthMedia", "taggedProductCard"];

const isMediaSide = (bloks?: { component?: string }[]) =>
	bloks?.some((b) => MEDIA_COMPONENTS.includes(b.component ?? "")) ?? false;

export const SideBySideBlok = ({ blok, preview }: BlokProps<BlokSideBySide>) => {
	const height = (blok.height || undefined) as "small" | "medium" | "large" | undefined;
	const heightMobile = (blok.heightMobile || undefined) as "small" | "medium" | "large" | undefined;
	const leftIsMedia = isMediaSide(blok.left);
	const rightIsMedia = isMediaSide(blok.right);

	return (
		<SegmentControl segments={blok}>
			<BlokWrap data-animate editable={blok} asChild>
				<div className={styles.content}>
					<div
						data-fade
						className={clsx(styles.side)}
						data-height={height}
						data-height-mobile={leftIsMedia ? heightMobile : undefined}
					>
						{blok.left && (
							<StoryblokComponentList
								bloks={blok.left}
								preview={preview}
								className={styles.contentMedia}
								dataHeight={height}
								dataHeightMobile={heightMobile}
							/>
						)}
					</div>
					<div
						data-fade
						className={clsx(styles.side)}
						data-height={height}
						data-height-mobile={rightIsMedia ? heightMobile : undefined}
					>
						{blok.right && (
							<StoryblokComponentList
								bloks={blok.right}
								preview={preview}
								className={styles.contentMedia}
								dataHeight={height}
								dataHeightMobile={heightMobile}
							/>
						)}
					</div>
				</div>
			</BlokWrap>
		</SegmentControl>
	);
};
